import type { PrimaryFilterId } from '../../../filters/types/filters';
import { ChartFallback } from '../../Chart/ChartFallback';
import { useChart } from '../../Chart/ChartProvider';
import type { CompensationChartType } from '../../PageConfigProvider/types/chart';
import type { PayMetricValues } from '../../PageConfigProvider/types/metric';
import { usePageState } from '../../PageState/PageStateProvider';
import { CompetitorDataProvider } from '../CompetitorDataProvider';
import type { DataProviderChildren, DataProviderSet } from '../types';
import { CompensationDataProvider } from './CompensationDataProvider';

type CompensationTopCompetitorsDataProviderProps = {
  primaryDimension: PrimaryFilterId;
  chartType: CompensationChartType;
  metric: PayMetricValues;
  exchangeRate?: number;
  children: DataProviderChildren<DataProviderSet | undefined>;
};
export const CompensationTopCompetitorsDataProvider = ({
  chartType,
  primaryDimension,
  metric,
  exchangeRate,
  children,
}: CompensationTopCompetitorsDataProviderProps) => {
  const { pageState } = usePageState();
  const { item } = useChart();
  const selectedEntity = pageState.primaryEntities?.[item?.id];

  return (
    <CompetitorDataProvider entityId={Number(selectedEntity?.id)}>
      {({ data: entities, status }) => (
        <ChartFallback status={status}>
          <CompensationDataProvider
            chartType={chartType}
            primaryDimension={primaryDimension}
            metric={metric}
            exchangeRate={exchangeRate}
            entitiesOverride={entities}
          >
            {children}
          </CompensationDataProvider>
        </ChartFallback>
      )}
    </CompetitorDataProvider>
  );
};
